import { render, staticRenderFns } from "./MailvelopeEditor.vue?vue&type=template&id=a6a82246&scoped=true"
import script from "./MailvelopeEditor.vue?vue&type=script&lang=js"
export * from "./MailvelopeEditor.vue?vue&type=script&lang=js"
import style0 from "./MailvelopeEditor.vue?vue&type=style&index=0&id=a6a82246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a82246",
  null
  
)

export default component.exports